<template>
    <div>
        <div style="padding:10px">
            <div @click="() => {$GlobalStore.closeLastModal()}" style="color:#808080;width:100px;">닫기</div>
        </div>
        <div style="flex:1; overflow:auto; padding:12px;">
            <div style="padding:20px 0px; text-align:center;">
                <div style="font-size:32px; font-weight:bold; color:#210F03;">선수 이력</div>
                <div style="font-size:16px; font-weight:500; color:#210F03;line-height: 24px; margin-top:20px;">KFA 선수 경력증명서에 기록되지 않았거나<br>지금까지 활동했던 다른 팀이나 축구교실이 있다면<br>작성해주세요</div>
            </div>

            <div v-for="each, i in changed_career_history" :key="i" class="career_history_wrap">
                <div style="display: flex;">
                    <div style="flex:1; font-size:16px; font-weight:500; color:#210F03">소속팀</div>
                    <!--<div style="width:50px; text-align:right;" @click="deleteCareer(i)">-->
                        <!--<img :src="require('@/assets/images/mypage/ico-can2.png')" style="width:16px;">-->
                    <!--</div>-->
                </div>
                <div class="input_wrap" style=" margin-top:12px;">
                    <div style="position:relative; flex:1;">
                        <input class="career_history_input" type="text" placeholder="소속팀명" style="width:100%;" :ref="'career_history_team_name_' + i" v-model="each.team_name">
                        <img v-if="each.team_name.length > 0" style="position:absolute; right:10px; top:14px;width:20px; height:20px;" :src="require('@/assets/images/coach_register/coach_regi_x_btn.png')" @click="() => {each.team_name = ''}">
                    </div>

                    <CoachCareerRoleSelector :set-role="(role) => {each.role = role}" :init-role="each.role"/>

                    <!--<div style="position:relative;">-->
                        <!--<input class="career_history_input" type="text" placeholder="역할" style="width:100px;" :ref="'career_history_role_' + i" v-model="each.role">-->
                        <!--<img v-if="each.role.length > 0" style="position:absolute; right:10px; top:14px;width:20px; height:20px;" :src="require('@/assets/images/coach_register/coach_regi_x_btn.png')" @click="() => {each.role = ''}">-->
                    <!--</div>-->
                </div>
                <div class="input_wrap" style=" margin-top:12px;">
                    <div style="position:relative;">
                        <input class="career_history_input" type="tel" placeholder="입단일(2023.01)" maxlength="7" style="flex:1;width:100%;" :ref="'career_history_join_date_' + i" v-model="each.join_date">
                        <img v-if="each.join_date.length > 0" style="position:absolute; right:10px; top:14px;width:20px; height:20px;" :src="require('@/assets/images/coach_register/coach_regi_x_btn.png')" @click="() => {each.join_date = ''}">
                    </div>
                    <div style="position:relative;">
                        <input class="career_history_input" type="tel" placeholder="탈퇴일(2023.02)" maxlength="7" style="flex:1;width:100%;" :ref="'career_history_exit_date_' + i" v-model="each.exit_date">
                        <img v-if="each.exit_date.length > 0" style="position:absolute; right:10px; top:14px;width:20px; height:20px;" :src="require('@/assets/images/coach_register/coach_regi_x_btn.png')" @click="() => {each.exit_date = ''}">
                    </div>
                </div>
            </div>
            <div style="padding:15px 0px; " @click="addCareer">
                <div style="font-size:14px; font-weight:bold; color:#699BF7;">선수 이력 추가하기</div>
            </div>
            <div style="height:100px;"></div>
        </div>
        <div style="padding:12px;">
            <div style="display:grid; place-items: center; height:48px; background-color: black; color:white; font-size:14px; font-weight:500; border-radius:12px " @click="saveCareerHistory">저장하기</div>
        </div>
    </div>
</template>

<script>
    import ResponseCode from "../../../ResponseCode";
    import CoachCareerRoleSelector from "../../common/CoachCareerRoleSelector";

    export default {
        name: "CoachCareerRegister",
        components: {CoachCareerRoleSelector},
        props : {
            completeAction : {
                type : Function,
                default : () => {}
            }
        },
        data(){
            return {
                career_history : [],
                changed_career_history : [],
            }
        },
        methods : {
            setInputEvent(i) {
                this.$nextTick(() => {
                    this.$Util.setYearDotMonthFormmater(this.$refs['career_history_join_date_' + i][0]);
                    this.$Util.setYearDotMonthFormmater(this.$refs['career_history_exit_date_' + i][0]);
                })
            },
            addCareer() {
                this.changed_career_history.push({
                    team_name: '',
                    role: '',
                    join_date: '',
                    exit_date: '',
                });

                this.setInputEvent(this.changed_career_history.length - 1);
            },
            deleteCareer(i) {
                this.changed_career_history.splice(i, 1);
            },
            async getMyCareerHistory(){
                const res = await this.$Axios.get('/api/member/career_history');

                const data = res.data;

                this.career_history = data.career_history;
                this.changed_career_history = window.copyObject(data.career_history);

                this.$nextTick(() => {
                    this.career_history.forEach((each, index) => {
                        this.setInputEvent(index);
                    });
                });
            },
            async saveCareerHistory() {
                for (let i = 0; i < this.changed_career_history.length - 1; i++) {
                    const each = this.changed_career_history[i];
                    if (each.team_name === '' && each.role === '' || each.join_date === '' || each.exit_date === '') continue;

                    if (each.team_name === '') {
                        this.$GlobalStore.showAlert('소속팀명을 입력해주세요.');
                        return;
                    }

                    if (each.role === '') {
                        this.$GlobalStore.showAlert('역할을 입력해주세요.');
                        return;
                    }

                    if (each.join_date.length !== 7) {
                        this.$GlobalStore.showAlert('입단일을 형식에 맞게 입력해주세요. (2023.10)');
                        return;
                    }
                    if (each.exit_date.length !== 7) {
                        this.$GlobalStore.showAlert('탈퇴일을 형식에 맞게 입력해주세요. (2023.10)');
                        return;
                    }
                }

                const parameters = {};
                parameters.career_history = this.changed_career_history;

                this.$Util.sendEventClick('코치선수이력_저장');

                const res = await this.$Axios.post('/api/member/career_history/save', parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.completeAction();
                    this.$GlobalStore.closeLastModal();
                    // this.getMemberInfo(false);
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
        },
        created(){
            this.saveCareerHistory = this.$Once(this.saveCareerHistory);
            this.getMyCareerHistory();

        }
    }
</script>

<style scoped>
    .career_history_input{border:0px; border-radius:12px; height:48px; outline: none; background-color: #f5f5f5; font-size:14px; font-weight:500; color:#210F03; padding-left:12px; padding-right:30px; width:100%;}
    .career_history_wrap + .career_history_wrap{margin-top:30px;}
    .input_wrap{display: flex; gap:12px;}

</style>